import { IIconsProps } from "./icons.model";

const PreVendaIcon = (props: IIconsProps) => {
  return (
    <img
      id={props.id}
      src={"/icon/menu/pre_venda.svg"}
      alt=""
      style={{ width: props.fontSize, height: props.fontSize }}
    />
  );
};

export default PreVendaIcon;
